import React, { useEffect, useState } from 'react';
import { accountFormIsVisible, sessionKey } from '../../redux/selectors/pagesSelectors';
import { checkKey, setAccountFormIsVisible, setAccountFormRegisterState } from '../../redux/actions/pagesActions';
import { connect } from 'react-redux';
import { authEmailSelector } from '../../redux/selectors/authSelectors';
import { logout } from '../../redux/actions/authActions';
import TotalBill from '../TotalBill';
import cn from 'classnames';
import { productCurrentProductIdSelector } from '../../redux/selectors/productSelector';

function RegisterBlock({ sessionKey, email, checkKey, logout, setFormState, setFormIsVisible, mainProductId }) {
    useEffect(() => {
        checkKey();
    }, []);

    const openRegistrationForm = () => {
        setFormState(false);
        setFormIsVisible(true);
    }

    const openLoginForm = () => {
        setFormState(true);
        setFormIsVisible(true);
    }

    const logoutHandler = () => {
        logout({ product_id: mainProductId });
    }

    return (
        <div className={'header__user-info header__link-border'}>
            <div
                className={cn(
                    'container flex flex--end full-width flex--center flex--mobile-space-between',
                    {
                        'flex--mobile-j-start': !sessionKey,
                    }
                )}
            >
                {sessionKey ? (
                    <>
                        {email && (
                            <div className={'header__email-block'}>
                                <span className={'color--dark-grey hide-tablet'}>Account is</span>{' '}
                                <span className={'header__mail'}>{email}</span>
                            </div>
                        )}
                        <span className={'header__link-border logout'}>
                            <button type={'button'} onClick={logoutHandler} className={'header__link'}>
                                Logout
                            </button>
                        </span>
                    </>
                ) : (
                    <span className={'color--blue-2'}>
                        <a onClick={openLoginForm} href={'#'}>Sign In</a>
                         <span> | </span>
                        <a onClick={openRegistrationForm} href={'#'}>Create account</a></span>
                )}

                <TotalBill />
            </div>
        </div>
    );
}

const mapStateToProps = (state) => ({
    sessionKey: sessionKey(state),
    email: authEmailSelector(state),
    formIsVisible: accountFormIsVisible(state),
    mainProductId: productCurrentProductIdSelector(state),
});

const mapDispatchToProps = (dispatch) => ({
    checkKey: (data) => dispatch(checkKey(data)),
    logout: (params) => dispatch(logout(params)),
    setFormIsVisible: (flag) => dispatch(setAccountFormIsVisible(flag)),
    setFormState: (flag) => dispatch(setAccountFormRegisterState(flag)),
});

export default connect(mapStateToProps, mapDispatchToProps)(RegisterBlock);
